import { DateTime } from 'luxon';
import { useEffect } from 'react';

import { MAX_TIMEOUT_MS } from '@/configs/constants';
import { routerUrls } from '@/configs/routes/routerUrls';
import { useAlertsStore, useUserStore } from '@/configs/store';

const WARN_BEFORE = { minutes: 10 };

/**
 * За 10 минут до протухания токена Яндекса предупреждаем: потом страница уведёт на вход,
 * и незаписанный лог пропадёт. Ссылка открывает вход в новой вкладке — открытая форма цела
 */
export const useYandexTokenWarning = () => {
  const userStore = useUserStore();
  const { addAlert } = useAlertsStore();
  const expiresAt = userStore.user?.accessTokenExpiresAt ?? null;
  const { hasYandexAccess } = userStore;

  useEffect(() => {
    if (!hasYandexAccess || !expiresAt) return;

    const warnIn = DateTime.fromISO(expiresAt).minus(WARN_BEFORE).diffNow().as('milliseconds');

    // shortcut: токены живут 12 часов; срок дальше ~24 суток просто не предупреждаем
    if (warnIn > MAX_TIMEOUT_MS) return;

    const timer = setTimeout(
      async () => {
        // Токен могли обновить в другой вкладке — тогда срок сдвинется и эффект перезапустится
        await userStore.fetchMe().catch(() => null);

        const freshExpiresAt = userStore.user?.accessTokenExpiresAt;

        if (!freshExpiresAt || freshExpiresAt !== expiresAt) return;

        addAlert({
          title: 'Токен Яндекс Трекера скоро истечёт',
          message: `В ${DateTime.fromISO(expiresAt).toFormat('HH:mm')} старый учёт перестанет сохранять логи и откроется вход. Чтобы не потерять работу, {link} заранее.`,
          links: [{ marker: '{link}', text: 'войдите токеном', url: routerUrls.login }],
          withReload: false,
          autoClose: false,
        });
      },
      Math.max(warnIn, 0),
    );

    return () => clearTimeout(timer);
  }, [hasYandexAccess, expiresAt, userStore, addAlert]);
};
